import React from "react";
import { Modal } from "../CustomModal/Modal";
import { Strings } from "../../Resources/Strings/i18n";
import img_app_store from "../../Resources/Images/img_app_store.png";
import img_google_play from "../../Resources/Images/img_google_play.png";
import "./InstallAppModal.scss"

function InstallAppModal(props) {
  return (
    <div className="InstallAppContainer">
      <Modal
        show={props.openInstallApp}
        handleClose={props.hideModal}
        parent={"login"}
      >
        {
          <div className="appInstallModal">
            <div className="errorOtp">
              <div className="errorModal">
                <div className="modalTitle">
                  <p id="errorTitle">
                    <span id="errorText">{Strings("InstallApp")}</span>
                  </p>
                </div>
                <div className="errorContainer">
                  <div className="errorContent">
                    <p>{Strings("InstallAppInfo")}</p>
                    <div>
                      <a
                        // href="https://allwellapp.com/"
                        onClick={() => {
                          window.open("https://allwellapp.com/free", "_self");
                          setTimeout(() => {
                            props.hideModal()
                          }, 100);
                        }}
                      >
                        <img src={img_google_play} alt={img_google_play} />
                      </a>
                      <a
                        //href="https://allwellapp.com/"
                        onClick={() => {
                          window.open("https://allwellapp.com/free", "_self");
                          setTimeout(() => {
                            props.hideModal()
                          }, 100);
                        }}
                      >
                        <img src={img_app_store} alt={img_app_store} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </Modal>
    </div>
  );
}

export default InstallAppModal;
